import { FC } from 'react';
import { Th } from '@chakra-ui/react';
import { BoxProps, Button, Text, Box } from '@chakra-ui/react';
import { ICON_BY_NAME } from '../../Icons/Icon';
export interface CbTableHeaderTextProps extends BoxProps {
  columnKey?: string;
  isActive?: boolean;
  isAscending?: boolean;
  isDarkMode?: boolean;
  isSortable?: boolean;
  isUppercase?: boolean;
  text: string;
  textColor?: string;
  onHeaderClick?: (key: string) => void;
}
export const CbTableHeaderText: FC<CbTableHeaderTextProps> = ({
  columnKey = '',
  isActive,
  isAscending = true,
  isDarkMode,
  isSortable,
  isUppercase = false,
  text,
  textColor = 'text.primary',
  onHeaderClick,
  ...props
}) => {
  const buttonVariant = isDarkMode ? 'cb-outlineWhite' : 'cb-outline';
  const handleClick = () => {
    onHeaderClick && onHeaderClick(columnKey);
  };
  return <Th borderBottom="none" textAlign="left" padding={1} data-sentry-element="Th" data-sentry-component="CbTableHeaderText" data-sentry-source-file="CbTableHeaderText.tsx">
      {isSortable && columnKey.length ? <Button display="block" lineHeight={1} paddingX="18px" paddingTop="19px" paddingBottom="15px" borderRadius={0} variant={buttonVariant} border="none" height="auto" minWidth="auto" width="100%" textAlign="left" fontSize="md" color={textColor} fontWeight="bold" onClick={handleClick}>
          {text}
          <ICON_BY_NAME.chevrondownwide opacity={isActive ? 1 : 0} marginLeft="6px" paddingTop={!isAscending ? '2px' : '0'} transform={isAscending ? 'rotate(180deg)' : ''} width={3} />
        </Button> : <Box>
          <Text display="block" lineHeight={1} paddingY={4} paddingX={10} fontSize="md" color={textColor} fontWeight="bold" height="auto" minWidth="auto" width="100%" textAlign="left" textTransform={isUppercase ? 'uppercase' : 'none'} {...props}>
            {text}
          </Text>
        </Box>}
    </Th>;
};